import { useBreakpointValue, useColorModeValue } from '@chakra-ui/react'

export const useMSTRStyles = () => {
  const gridTemplateColumns = useBreakpointValue({
    base: 1,
    sm: 2,
    md: 3,
    lg: 4
  }) as number | undefined

  const cardBg = useColorModeValue('white', 'gray.800')
  const statCardBg = useColorModeValue('gray.50', 'gray.700')
  const borderColor = useColorModeValue('gray.200', 'gray.600')
  const accentColor = 'orange.500'  // Changed to orange for MSTR branding
  const textColor = useColorModeValue('gray.800', 'white')
  const subtitleColor = useColorModeValue('gray.600', 'gray.400')
  const positiveColor = useColorModeValue('green.500', 'green.300')
  const negativeColor = useColorModeValue('red.500', 'red.300')

  return {
    accentColor,
    borderColor,
    cardBg,
    gridTemplateColumns,
    negativeColor,
    positiveColor,
    statCardBg,
    subtitleColor,
    textColor
  }
}

export const chartStyles = {
  height: 400,
  width: '100%'
}

export const newsStyles = {
  maxHeight: '500px',
  overflowY: 'auto'
}
